import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course01 from "../../../course/course-01/course";
import course02 from "../../../course/course-02/course";
import lesson0106 from "../../course-01/lesson-06/lesson";
import lesson0212 from "../../course-02/lesson-12/lesson";
import lesson0213 from "../../course-02/lesson-13/lesson";
import lesson0215 from "../../course-02/lesson-15/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "69357e24-335c-4db9-9e04-af6dd44e0e5d",
    course: {
      id: course01.id,
      slug: course01.slug as string,
      name: course01.name,
      publicId: course01.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course01, lesson0106),
    lesson: lesson0106,
  },
  {
    id: "697b5a02-5332-495d-b807-974da62ad1af",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0212),
    lesson: lesson0212,
  },
  {
    id: "725eeaab-cb14-4bcb-a089-0c0a63ecc5a4",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0213),
    lesson: lesson0213,
  },
  {
    id: "26c4b919-934b-43d8-9908-9bd75a2d2e2c",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0215),
    lesson: lesson0215,
  },
];

export default lessonLinks;
